import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Clock, ArrowLeft } from 'lucide-react';
import posts from '@/content/blog';

export default function BlogListPage() {
    return (
        <div className="min-h-screen bg-[#09090B] relative overflow-hidden flex flex-col">
            {/* Background patterns */}
            <div className="absolute inset-0 grid-pattern opacity-20 pointer-events-none" />
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[1000px] h-[400px] bg-cyan-500/20 blur-[120px] rounded-full pointer-events-none" />

            {/* Navbar */}
            <nav className="relative z-10 border-b border-white/5 bg-black/20 backdrop-blur-md">
                <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
                    <Link to="/" className="flex items-center gap-3">
                        <div className="w-8 h-8 bg-cyan-500 rounded-lg flex items-center justify-center">
                            <Clock className="w-5 h-5 text-black" />
                        </div>
                        <span className="text-lg font-bold text-white font-['Manrope']">InSynq</span>
                    </Link>
                    <div className="flex items-center gap-4">
                        <Link to="/login">
                            <Button variant="ghost" className="text-zinc-400 hover:text-white">Sign In</Button>
                        </Link>
                        <Link to="/register">
                            <Button className="bg-white text-black hover:bg-zinc-200">Get Started</Button>
                        </Link>
                    </div>
                </div>
            </nav>

            {/* Main Content */}
            <main className="flex-1 relative z-10 max-w-4xl mx-auto w-full px-6 py-12">
                <div className="mb-12 text-center">
                    <h1 className="text-4xl font-bold text-white mb-4 font-['Manrope']">Blog</h1>
                    <p className="text-zinc-400">Latest updates and insights from the team.</p>
                </div>

                <div className="grid gap-6">
                    {posts.map((post) => (
                        <Link key={post.slug} to={`/blog/${post.slug}`} className="block group">
                            <article className="p-6 rounded-2xl bg-zinc-900/50 border border-white/5 hover:border-cyan-500/20 hover:bg-zinc-900/80 transition-all duration-300">
                                <div className="flex items-baseline justify-between mb-2">
                                    <h2 className="text-2xl font-semibold text-white group-hover:text-cyan-400 transition-colors font-['Manrope']">
                                        {post.meta.title}
                                    </h2>
                                    <span className="text-sm text-zinc-500 font-mono">{post.meta.date}</span>
                                </div>

                                <p className="text-zinc-400 mb-4">{post.meta.description}</p>
                                <div className="flex items-center text-sm text-cyan-500 font-medium">
                                    Read more <ArrowLeft className="w-4 h-4 ml-1 rotate-180 group-hover:translate-x-1 transition-transform" />
                                </div>
                            </article>
                        </Link>
                    ))}
                </div>
            </main>
        </div>
    );
}
